module.exports = __webpack_public_path__ + "img/moon.00fae965.svg";